import * as React from "react"
import Layout from "../components/layout"
import { HeroImageSection } from "../components/hero_image_section";
import { SaleDescriptionSection } from "../components/sale_description_section";
import { YouTubeSection } from "../components/youtube_section";
import { OfficialSnsSection } from "../components/official_sns_section";
import { ProductDetailsSection } from "../components/product_details_section";
import { StaffSection } from "../components/staff_section";
import { PressKitSection } from "../components/press_kit_section";
import { SteamStoreSection } from "../components/steam_store";
import "@fontsource/zen-old-mincho/400.css"
import "@fontsource/zen-old-mincho/600.css"
import "@fontsource/zen-kaku-gothic-new/500.css"
import "@fontsource/zen-antique/400.css"
import { ModalSection } from "../components/modal_section";
import { useState } from "react";

export const Head = () => (
  <head>
    <title>アイリス・オデッセイ</title>
    <meta name="description" content={"現代ファンタジーADV 『アイリス・オデッセイ』公式サイト 2025年夏発売予定"} />
    <meta property="og:title" content={"アイリス・オデッセイ"} />
    <meta property="og:description" content={"現代ファンタジーADV 『アイリス・オデッセイ』公式サイト 2025年夏発売予定"} />
    <meta property="og:type" content={"website"} />
    <meta property="og:url" content="https://iris-odyssey.jp/" />
    <meta property="og:site_name" content={"アイリス・オデッセイ"} />
    <meta property="og:image" content={"https://iris-odyssey.jp/ogp_image.jpg"} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:creator" content={"IrisOdysseyJP"} />
    <meta name="twitter:title" content={"アイリス・オデッセイ"} />
    <meta name="twitter:description" content={"現代ファンタジーADV 『アイリス・オデッセイ』公式サイト 2025年夏発売予定"} />
  </head>
)

export default function GameTeaser() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const onClose = () => setIsModalOpen(false);
  return (
    <Layout>
      {isModalOpen && <ModalSection onClose={onClose}/>}
      <HeroImageSection />
      <SaleDescriptionSection />
      <YouTubeSection />
      {/* <SteamStoreSection /> */}
      <OfficialSnsSection />
      <StaffSection />
      <ProductDetailsSection />
      <PressKitSection />
    </Layout>
  );
}